import { render } from "./signupCom.vue?vue&type=template&id=1b87705a&scoped=true"
import script from "./signupCom.vue?vue&type=script&lang=js"
export * from "./signupCom.vue?vue&type=script&lang=js"

import "./signupCom.vue?vue&type=style&index=0&id=1b87705a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b87705a"]])

export default __exports__